import StandaloneSvgChartRange from '@/pages/Dashboards/Charts/SVGChart/StandaloneSvgChartRange'
import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import { useMemo } from 'react'
import liftWinchPowerConfig from '../liftWinchPower.config'
import liftWinchPowerSvgSettings from '../liftWinchPower.svgSettings'
import liftWinchPowerSrc from '../liftWinchPowerWidget.src'
import LiftWinchPowerWidgetLegent from '../LiftWinchPowerWidgetLegent'

import useLastErrorEvent from '@/pages/Equipment/hooks/useErrorEventUpToTsRef'
import useForceUpdate from '@/shared/hooks/useForceUpdate'

/**
 * RUN = MDRunSgl
 * READY = MDReadySgl
 * BRK = BRCxControlFlag
 * LKMC = LKMCCmd
 * ONKMC = ONKMCSgl
 * W, V, U = факт питания, тоже MDReadySgl
 * L160, L161 = MDReadySgl
 * BRC1 = BRC1Sgl
 * BRC2 = BRC2Sgl
 * BRC0 = BRCxControlFlag
 * EMBRK = K7RelayState
 */

interface IProps {
  equipmentId: IEquipment['id']

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const LiftWinchPowerRange = (props: IProps) => {
  const forceUpdate = useForceUpdate()

  const eventsData = useLastErrorEvent({ ...props, onNewValueReceived: forceUpdate })

  const widgetConfig: ISVGChartWidget = useMemo(
    () => liftWinchPowerConfig.generateWidgetConfig(liftWinchPowerSvgSettings(props.equipmentId)),
    [props.equipmentId]
  )
  const computedParameters = useMemo(() => liftWinchPowerConfig.generateParameters(null, eventsData.ref), [])

  const renderContent = () => {
    if (eventsData.loading) return <ThreeDotsLoader inscription="Загрузка данных..." />
    return (
      <StandaloneSvgChartRange
        {...props}
        tsCurrent={eventsData.lastUpdateTsRef.current}
        wrapperStyle={{ alignItems: 'start' }}
        svgFileSrcString={liftWinchPowerSrc}
        widget={widgetConfig}
        computed={computedParameters}
      />
    )
  }

  return (
    <div className="flex-lines gap16 height100 width100" style={{ minHeight: 0, position: 'relative' }}>
      <LiftWinchPowerWidgetLegent />
      <div className="height100 width100 flex-lines center">{renderContent()}</div>
    </div>
  )
}

export default LiftWinchPowerRange
